import { render } from "./listar_mensagens.vue?vue&type=template&id=58e41a8e&scoped=true"
import script from "./listar_mensagens.vue?vue&type=script&lang=js"
export * from "./listar_mensagens.vue?vue&type=script&lang=js"

import "./listar_mensagens.vue?vue&type=style&index=0&id=58e41a8e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e41a8e"]])

export default __exports__